import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import AboutSection from '../components/sections/AboutSection';
import { useAbout, useSiteConfig } from '../context/CMSContext';

const About: React.FC = () => {
  const about = useAbout();
  const siteConfig = useSiteConfig();

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <Header />
      <main>
        <section className="relative bg-slate-900 py-32">
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-800" />
          <div className="container mx-auto px-4 relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{about.sectionTitle}</h1>
            <p className="text-slate-300 text-lg max-w-2xl">{siteConfig.description}</p>
          </div>
        </section>
        <AboutSection forceShow />
      </main>
      <Footer />
    </div>
  );
};

export default About;
